// This file is automatically generated. Do not edit manually.

import { IsoDateTimeString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationDetailsViewApi {
	export async function getPartConfiguration(args: {
		partConfigurationId: number;
	}): Promise<PartConfigurationDetailsViewApi_PartConfigurationDto> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/details/getPartConfiguration",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as PartConfigurationDetailsViewApi_PartConfigurationDto;
	}
}

export interface PartConfigurationDetailsViewApi_PartConfigurationDto {
	isEditable: boolean;
	recursiveWorkCost: number;
	totalCostInSellingCurrency: number | null | undefined;
	basePrice: number;
	capacityQuantity: number | null | undefined;
	catalogPartId: number;
	catalogPartRevisionId: number;
	configurationContentHash: string;
	configurationLogPathBase64: string;
	createdAt: IsoDateTimeString;
	createdByAppUserName: string;
	createdByUserId: number;
	customerOrderTypeId: number | null | undefined;
	customerOrderTypeName: string | null | undefined;
	defaultProductionLineId: number | null | undefined;
	defaultProductionLineName: string | null | undefined;
	description: string;
	discountPercentage: number;
	domesticCurrencyCode: string;
	domesticCurrencyId: number;
	editedManually: boolean;
	lastUpdated: IsoDateTimeString;
	materialCost: number;
	partConfigurationId: number;
	partDescription_1: string;
	partDescription_2: string;
	partId: number;
	partLongName: string | null | undefined;
	partNo: string;
	partRevisionId: number;
	partRevisionNote: string;
	printoutText: string;
	productFamilyId: number;
	productFamilyVersionId: number;
	productFamilyVersionNumber: number;
	revisionNumber: number;
	salesPrice: number;
	sellingCurrencyCode: string;
	sellingCurrencyId: number;
	siteId: number;
	totalCost: number;
	weight: number | null | undefined;
	workCost: number;
	workInstructions: string;
}
